// extracted by mini-css-extract-plugin
export default {"wrapper":"feed-order-details_wrapper__nQ3us","header":"feed-order-details_header__-I3hM","footer":"feed-order-details_footer__OnuPB"};